interface AppInfo {
  deployEnv: 'prod' | 'staging' | 'dev'
  imageUrl: string
}

export function getAppInfo(): AppInfo {
  const appInfoString = localStorage.getItem('appInfo')
  if (!appInfoString) {
    throw new Error('No appInfo found in localStorage')
  }
  const appInfo = JSON.parse(appInfoString)
  return appInfo
}

export function getImageUrl(name: string): string {
  // Safety net: pass full URLs through unchanged. The backend should always
  // return bare filenames, but this prevents double-wrapping if it ever doesn't.
  if (name.startsWith('http://') || name.startsWith('https://')) {
    return name
  }
  const { imageUrl } = getAppInfo()
  return `${imageUrl}/${name}`
}

export function getAssetUrl(path: string): string {
  const appInfo = getAppInfo()
  const baseUrls = {
    prod: 'https://jdj.club/assets',
    staging: 'https://staging.jdj.club/assets',
    dev: 'https://asset-dev.jdj.club',
  }
  const baseUrl = baseUrls[appInfo.deployEnv]
  return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`
}
